// Mount point for the read-only policy cards on Checkout (#36363).
const CheckoutPolicyCards = () => null;

export default CheckoutPolicyCards;
